/* unplugin-vue-components disabled */import script from "./MobileRegisterPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileRegisterPopup.vue?vue&type=script&setup=true&lang=js"

import "./MobileRegisterPopup.vue?vue&type=style&index=0&id=75639cb2&lang=scss"

const __exports__ = script;

export default __exports__